export default {
    SET_CURRENT_BREADCRUMB: (state, breadcrumb) => {
        state.currentBreadcrumb = breadcrumb;
    },
    SET_BREADCRUMB: (state, breadcrumbs) => {
        state.breadcrumbs = breadcrumbs;
    },
    PUSH_BREADCRUMB: (state, breadcrumb) => {
        let ifPush = true;
        // for(let i = state.breadcrumbs.length - state.currentBreadcrumb.length; i<state.breadcrumbs.length; i++){
        //     if (_.isEqual(breadcrumb, state.breadcrumbs[i])){
        //         ifPush = false;
        //         return
        //     }
        // }

        if ( _.findIndex( state.breadcrumbs, breadcrumb) === -1){
            ifPush = true

        }else{
            ifPush = false
        }
        if (ifPush){
            state.breadcrumbs.push(breadcrumb)
        }
    },
    POP_BREADCRUMB: (state, breadcrumbs) => {
        state.breadcrumbs.pop();
    },
    EMPTY_BREADCRUMB: (state, breadcrumbs) => {
        state.breadcrumbs = [];
    },
    REMOVE_CURRENT_BREADCRUMB: (state) => {
        let removedBreads;
        removedBreads = state.breadcrumbs.filter(
            ar => {
                // // console.log(state.currentBreadcrumb.find(rm => {
                //     // console.log(rm, 'rm')
                //     // console.log(ar, 'ar')
                //     // console.log(_.isEqual(rm , ar))
                //     return rm == ar
                // }))
                 return !state.currentBreadcrumb.find(rm => {
                    return _.isEqual(rm , ar)
                })
            });

        state.breadcrumbs = removedBreads;
    },
    REMOVE_FROM_INDEX: (state, item) => {
        let index = _.findIndex(state.breadcrumbs, {text: item.text});
        if (index !== -1) {
            state.breadcrumbs.splice(index + 1, state.breadcrumbs.length - 1)
        }
    },
}
